/*
    Vsion：  3.0.2.2
    Actor：  CSG
    DATE:2021.08.23
*/

+(function (window) {
  'use strict';

  var _socket = null;

  //WEBSOCKET 对象建立
  var wsc = {
    /**WEBSOCKET连接 */
    getWSC: function (__config) {
      if (_socket && (__config.servicePath != _socket._config.servicePath)) {
        _socket._config.servicePath = __config.servicePath;
      }
      
      _socket = _socket || this.createWSC(__config);
      return _socket;
    },
    createWSC: function (__config) {
      var _config = $.extend({
        onOpen: null,
        onMess: null,
        onClose: null,
        onStatusChanage: function (status) {

        },
        //WEBSOCKET 服务端地址
        servicePath: "",
        //终端mac
        mac: "",
        //是否自定义地址
        isAutoPath: false,
      }, __config);

      return new communication_xm(_config);
    }
  };

  //WEBSOCKET 控制对象
  function communication_xm(__config) {
    var self = this;
    this._config = $.extend({
      onOpen: null,
      onMess: null,
      onClose: null,
      onStatusChanage: null,
      //WEBSOCKET 服务端地址
      servicePath: "",
      //mac地址
      mac: null,
      //是否自定义地址
      isAutoPath: false,
    }, __config);
    this._command = {
      "CommandHeader": {
        "Visitor": {
          "Rooms": [],
          "Meeting": 0,
          "Node": 0,
          "User": 0,
          "ClientType": 3,
          "VisitTime": Date.now(),
          "Mac": "",
        },
        "CommandType": {
          "Dispatch": 1
        }
      },
      "CommandData": {
        "Data": {
          "DataMarking": "",
          "DataContent": ""
        },
        "Target": {
          "Limit": []
        }
      }
    };
    this._commands = [];
    this._status = _status_comm.CLOSE;
    this._lastCommand = {
      //连接命令
      connect: null,
      //接收命令
      receive: null
    };
    this._socket = null;
    this._reconnect = {
      isReconn: false,
      errorMaxNum: 100,
      errorNum: 0,
      timeoutFun: null
    };

    //心跳信息
    this._heartbeat = {
      treatObject: null
      //心跳检测周期时间(毫秒)
      , checkHeartbeatTime: 10000
      //上次回复时间
      , replyTime: new Date()
    }

    //对外事件
    this.events = {
      _open: self._config.onOpen,
      _mess: self._config.onMess,
      _close: self._config.onClose,
      _statusChange: self._config.onStatusChanage,
      bind: function () {
        this._open = self._config.onOpen;
        this._mess = self._config.onMess;
        this._close = self._config.onClose;
        this._statusChange = self._config.onStatusChanage;
      },
      remove: function () {
        this._open = null;
        this._mess = null;
        this._close = null;
        this._statusChange = null;
      }
    };

    //初始化
    var _init = function () {
      var that = self;
      if (that._config.isAutoPath || isAutoIpRequest) {
        // 获取到的地址数组
        var matchArray = that._config.servicePath.match(regExpAddress);
        // 判断是否有端口号数据是否为域名访问
        if (matchArray[3]) {
          // websocket请求地址:有端口号的则使用配置端口号的规则
          that._config.servicePath = matchArray[1] + "://" + webSocketAutoIp + matchArray[3] + that._config.servicePath.replace(matchArray[0], "");
        } else {
          // 没有端口号的则使用不配置端口号的规则
          that._config.servicePath = matchArray[1] + "://" + webSocketAutoIp + that._config.servicePath.replace(matchArray[0], "");
        }
      }

      if (that._socket) {
        if (that._socket.readyState == WebSocket.OPEN) {
          _onOpen();
        } else {
          _connect(true);
        }
      } else {
        _connect();
      }
    }

    //WEBSCOKET 连接
    var _connect = function (__isReconn) {
      var that = self;

      //必须等WEBSOCKET对象连接已经关闭后才进入重连 2021.08.18
      if ((!that._socket) || that._socket.readyState == WebSocket.CLOSED) {
        _release();
        that._status = _status_comm.CONNECT;
        // 链接websocket对象
        that._socket = new WebSocket(that._config.servicePath + "?mac=" + that._config.mac + "&time=" + new Date().getTime() + "&rand=" + Math.random());

        //注册错误异常事件
        that._socket.onerror = function (evt) {
          try {
            if (that._status != _status_comm.CLOSE) {
              _errerTreat(evt);
              _onClose(false, evt);
            } else {
              _onClose(true, evt);
            }

          } catch (e) {
          }
        }

        //在注册关闭事件
        that._socket.onclose = function (evt) {
          if (that._status != _status_comm.CLOSE) {
            _errerTreat(evt);
            _onClose(false, evt);
          } else {
            _onClose(true, evt);
          }
        }

        that._socket.onopen = function () {
          _relieveReconnet();

          if (that._lastCommand.connect) {
            that._commands.splice(0, 0, that._lastCommand.connect);
          }
          if (that._lastCommand.receive) {
            that._commands.splice(0, 0, that._lastCommand.receive);
          }

          if (that._commands && that._commands.length > 0) {
            that._send();
          }

          _onOpen();
          //WEBSOCKET 心跳开始
          _heartbeat().start();
          that._socket.onmessage = function (evt) {
            //收到信息更新一下时间
            that._heartbeat.replyTime = new Date();
            _onMessage(evt);
          }
        }
      }

    }

    //发送信息
    this._send = function (_command) {
      var that = this;

      var _treatCommand = function (___command) {
        if (___command) {
          try {
            switch (___command.CommandHeader.CommandType.Dispatch) {
              case _dispatch_comm.Connect: {
                that._lastCommand.connect = ___command;
              }
                break;
              case _dispatch_comm.Receive: {
                that._lastCommand.receive = ___command;
              }
                break;
            }
          } catch (e) {
          }
        }
      }

      if (that._socket && that._socket.readyState == WebSocket.OPEN) {
        //发送待发命令
        if (that._commands && that._commands.length > 0) {
          var cmdLen = that._commands.length;
          for (var i = 0; i < cmdLen; i++) {
            var __command = that._commands[i];
            if (__command) {
              _treatCommand(__command);
              that._socket.send(JSON.stringify(__command));
            }
          }

          for (var i = cmdLen - 1; i >= 0; i--) {
            that._commands.splice(i, 1);
          }
        }
        //发送当前命令
        if (_command) {
          _treatCommand(_command);
          that._socket.send(JSON.stringify(_command));
        }
      } else if (that._status == _status_comm.CONNECTTING) {
        //正在连接中
        if (_command) {
          that._commands.push(_command);
        }
      } else if (that._status != _status_comm.CLOSE) {
        if (_command) {
          that._commands.push(_command);
        }
      }
    }

    //WEBSOCKET 释放
    var _release = function () {
      var that = self;
      if (that._socket) {
        that._socket.onerror = null;
        that._socket.onclose = null;
        that._socket.onopen = null;
        that._socket.onmessage = null;

        if (that._socket.readyState == WebSocket.OPEN) {
          that._socket.close();
        }
      }
    }

    //WEBSOCKET 关闭
    var _close = function () {
      var that = self;

      that._status = _status_comm.CLOSE;
      if (that._socket) {
        _onClose();
        that._socket.onerror = null;
        that._socket.onclose = null;
        that._socket.onopen = null;
        that._socket.onmessage = null;

        if (that._socket.readyState == WebSocket.OPEN) {
          that._socket.close();
        }
      }
    }

    //错误处理
    var _errerTreat = function () {
      var that = self;

      //业务状态非关闭，WEBSOCKET状态处于关闭的状态，那么需要重连
      if (that._status != _status_comm.CLOSE && ((!that._socket) || that._socket.readyState == WebSocket.CLOSED)) {
        //得触发重连了
        _reconnect();
      }
    }

    //WEBSOCKET 重连 - 托管
    var _reconnect = function () {
      var that = self;
      that._reconnect.isReconn = true;

      var _reconnectFun = function () {
        if (that._status != _status_comm.CLOSE && ((!that._socket) || that._socket.readyState == WebSocket.CLOSED)) {
          that._reconnect.errorNum += 1;
          //WEBSOCKET 心跳结束
          _heartbeat().stop();
          _connect(true);

          that._reconnect.timeoutFun = setTimeout(_reconnectFun, that._reconnect.errorNum * 1000);
        }
      }

      _reconnectFun();
    }

    //WEBSOCKET 解除重连
    var _relieveReconnet = function () {
      var that = self;
      that._reconnect.errorNum = 0;
      that._reconnect.isReconn = false;
      if (that._reconnect.timeoutFun) {
        clearTimeout(that._reconnect.timeoutFun);
        that._reconnect.timeoutFun = null;
      }
    }

    //WEBSOCKET 心跳检测
    var _heartbeat = function () {
      var that = self;
      that._heartbeat.treatObject = that._heartbeat.treatObject || {
        checkFun: null
        //开始心跳监测
        , start: function () {
          var __that = this;
          //最后一次发送时间
          var __lastSendTime = new Date();
          var __sendFun = function () {
            var __nowTime = new Date();
            //(__nowTime - __lastSendTime) 熄屏或者浏览器最小化后setInterval将停止，用于解决这个问题
            if (__nowTime - that._heartbeat.replyTime <= (__nowTime - __lastSendTime) + that._heartbeat.checkHeartbeatTime * 2) {
              __lastSendTime = new Date();
              //接收最后一条信息时间没有超过检测周期*2
              var __command = JSON.parse(JSON.stringify(that._command));
              __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Ping;
              that._send(__command);
            } else {
              __that.stop();
              //超过检测周期，表明WebSocket可能有异常
              _connect(true);
            }
          };

          __that.stop();
          that._heartbeat.replyTime = new Date();
          //起始时回复时间往前加上周期时间
          that._heartbeat.replyTime = that._heartbeat.replyTime.setMilliseconds(that._heartbeat.replyTime.getMilliseconds() + that._heartbeat.checkHeartbeatTime);

          __that.checkFun = setInterval(__sendFun, that._heartbeat.checkHeartbeatTime);
        }
        //停止心跳监测
        , stop: function () {
          var __that = this;
          if (__that.checkFun) {
            clearInterval(__that.checkFun);
            __that.checkFun = null;
          }
        }
      };

      return that._heartbeat.treatObject;
    }

    // 发送消息的时候，把心跳置为重新开始，这样在发送批注数据时能减少心跳发送数据，节省带宽和运算能力
    this.heartbeatReset = function () {
      // 停止心跳
      _heartbeat().stop();
      // 开始心跳
      _heartbeat().start();
    };

    //停止所有事件
    this._removeAll = function () {
      _relieveReconnet();
      _heartbeat().stop();
      _close();
    }

    //重新开启WEBSOCKET
    this._restart = function () {
      _connect();
    }

    var _onOpen = function () {
      var that = self;
      if (that.events._open) {
        that.events._open(that);
      }
    }
    var _onMessage = function (evt) {
      var that = self;

      if (that.events._mess) {
        that.events._mess(evt);
      }
    }
    var _onClose = function () {
      var that = self;

      if (that.events._close) {
        that.events._close();
      }
    }

    _init();
  }

  //扩展业务方法
  communication_xm.prototype = {
    // 多条限制方法
    sendTos_Room_Meeting_Nodes_Users_Client_Type: function (dataMarking, dataContent, where) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limitArr = [];
      for (var i = 0; i < where.length; i++) {

          var whereItem = where[i];

          var limit = { "Type": whereItem.type };
          if (whereItem.rooms && whereItem.rooms.length > 0) {
              limit.Rooms = whereItem.rooms;
          }
          if (whereItem.meetings && whereItem.meetings.length > 0) {
              limit.Meetings = whereItem.meetings;
          }
          if (whereItem.users && whereItem.users.length > 0) {
              limit.Users = whereItem.users;
          }
          if (whereItem.nodes && whereItem.nodes.length > 0) {
              limit.Nodes = whereItem.nodes;
          }
          if (whereItem.clients && whereItem.clients.length > 0) {
              limit.ClientTypes = whereItem.clients;
          }
          limitArr.push(limit);
      }
      __command.CommandData.Target.Limit = limitArr;

      that._sendCommand(__command);
    },
    /*发送链接请求*/
    connect: function (_visitor) {
      var that = this;
      if (_visitor)
        that._command.CommandHeader.Visitor = $.extend(that._command.CommandHeader.Visitor, _visitor);

      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      /*链接命令*/
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Connect;

      that._sendCommand(__command);

      return this;
    },
    /*简易数据发送*/
    simpleSend: function (dataMarking, dataContent) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      that._sendCommand(__command);
    }

    /*向指定会议发送数据*/
    ,
    sendTo_Meeting: function (dataMarking, dataContent, _meetingID) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;
      __command.CommandData.Target.Limit.push(
        {
          "Type": "Allow",
          "Meetings": [_meetingID],
        });

      that._sendCommand(__command);
    }

    /*
            /!*向指定会议发送数据*!/
            ,sendTo_Meeting_Client:function (dataMarking, dataContent, _meetingID, _clients) {
                var that = this;
                /!*拷贝命令*!/
                var __command = JSON.parse(JSON.stringify(that._command));
                __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
                __command.CommandData.Data.DataMarking = dataMarking;
                __command.CommandData.Data.DataContent = dataContent;
                __command.CommandData.Target.Limit.push(
                    {
                        "Type": "Allow",
                        "Meetings": [_meetingID],
                        "ClientTypes": _clients,
                    });

                that._sendCommand(__command);
            }
    */

    /*向指定类型终端发送数据*/
    ,
    sendTo_Meeting_Client: function (dataMarking, dataContent, _meetingID, _clients) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;
      __command.CommandData.Target.Limit.push(
        {
          "Type": "Allow",
          "Meetings": [_meetingID],
          "ClientTypes": _clients,
        });

      that._sendCommand(__command);
    }

    ,
    sendTo_Meeting_Users_Nodes: function (dataMarking, dataContent, _meetingID, _users, _nodes, _visitorUser) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));

      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": "Allow"};
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }

      if (_visitorUser != null) {
        __command.CommandHeader.Visitor.User = _visitorUser;
      }
      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    ,
    sendTo_Meeting_Nodes_Users_VisitorUser_Client: function (dataMarking, dataContent, _meetingID, _users, _nodes, _visitorUser, _clientTypes) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));

      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": "Allow"};
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }
      if (_clientTypes && _clientTypes.length > 0) {
        limit.ClientTypes = _clientTypes;
      }
      if (_visitorUser != null) {
        __command.CommandHeader.Visitor.User = _visitorUser;
      }

      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    ,
    sendTo_Room_Meeting_Nodes_Users: function (dataMarking, dataContent, _roomNo, _meetingID, _nodes, _users) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": "Allow"};
      if (_roomNo && _roomNo.length > 0) {
        limit.Rooms = [_roomNo];
      }
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }
      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    ,
    sendTo_Room_Meeting_Nodes_Users_Type: function (dataMarking, dataContent, _roomNo, _meetingID, _nodes, _users, Type) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": Type};
      if (_roomNo && _roomNo.length > 0) {
        limit.Rooms = [_roomNo];
      }
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }
      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    ,
    sendTo_Room_Meeting_Nodes_Users_Client_Type: function (dataMarking, dataContent, _roomNo, _meetingID, _nodes, _users, _clients, Type) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": Type};
      if (_roomNo && _roomNo.length > 0) {
        limit.Rooms = [_roomNo];
      }
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }
      if (_clients && _clients.length > 0) {
        limit.ClientTypes = _clients;
      }

      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    // 多会议室支持(后台由于不一定有会议，连接webSocket的meetingId是0，与后台交互需要使用会议室)
    ,
    sendTo_Rooms_Meeting_Nodes_Users_Type: function (dataMarking, dataContent, _roomNos, _meetingID, _nodes, _users, Type) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": Type};
      if (_roomNos && _roomNos.length > 0) {
        limit.Rooms = _roomNos;
      }
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }
      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    // 多会议室支持(后台由于不一定有会议，连接webSocket的meetingId是0，与后台交互需要使用会议室)
    ,
    sendTo_Rooms_Meeting_Nodes_Users_Client_Type: function (dataMarking, dataContent, _roomNos, _meetingID, _nodes, _users, _clients, Type) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      var limit = {"Type": Type};
      if (_roomNos && _roomNos.length > 0) {
        limit.Rooms = _roomNos;
      }
      if (_meetingID && _meetingID.length > 0) {
        limit.Meetings = _meetingID;
      }
      if (_users && _users.length > 0) {
        limit.Users = _users;
      }
      if (_nodes && _nodes.length > 0) {
        limit.Nodes = _nodes;
      }

      if (_clients && _clients.length > 0) {
        limit.ClientTypes = _clients;
      }

      __command.CommandData.Target.Limit.push(limit);

      that._sendCommand(__command);
    }

    /*发送并存储数据【发送且存储命令】*/
    ,
    sendStorage: function (dataMarking, dataContent) {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Send_Storage;
      __command.CommandData.Data.DataMarking = dataMarking;
      __command.CommandData.Data.DataContent = dataContent;

      that._sendCommand(__command);
    }

    /*接收数据【释放链接及接收命令以外的所有命令】*/
    ,
    receive: function () {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Receive;

      that._sendCommand(__command);
      return this;
    }

    /*接收数据和存储数据*/
    ,
    receiveStorage: function () {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Receive_Storage;

      that._sendCommand(__command);
      return this;
    }

    /*释放数据*/
    ,
    replace: function () {
      var that = this;
      /*拷贝命令*/
      var __command = JSON.parse(JSON.stringify(that._command));
      __command.CommandHeader.CommandType.Dispatch = _dispatch_comm.Replace;

      that._sendCommand(__command);
    }

    /*打开*/
    ,
    open: function () {
      var that = this;
      /*移除注册事件 */
      that.events.bind();
      that._restart();
    }

    /*关闭*/
    ,
    close: function () {
      var that = this;
      this._removeAll();
      /*移除注册事件 */
      this.events.remove();
    }


    /*发送命令*/
    ,
    _sendCommand: function (__command) {
      var that = this;
      if (__command) {
        //WEBSOCKET 心跳重置
        that.heartbeatReset();
        that._send(__command);
      }
    }
  }


  /*连接状态*/
  var _status_comm = {
    CLOSE: 0,
    CONNECT: 1,
  }

  /*发送命令类型*/
  var _dispatch_comm = {
    Connect: 1,
    CallBack: 2,
    Send: 3,
    Replace: 4,
    Prompt: 5,
    Receive: 6,
    Storage: 7,
    Multimedia: 8,
    Ping: 9,
    Pong: 10,
    Send_Storage: 103007,
    Receive_Storage: 106007
  }

  //工具与方法
  var _tools = {
    /*将对象属性转换成参数 */
    toUrlPara: function () {
      var _str = "";
      for (var a in this) {
        _str += a + "=" + encodeURI(this[a]) + "&";
      }
      return _str.length > 0 ? _str.substr(0, _str.length - 1) : "";
    }
  }

  if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) {
    define(function () {
      return wsc;
    });
  } else if (typeof module !== 'undefined' && module.exports) {
    module.exports.wsc = wsc;
    module.exports._status_comm = _status_comm;
  } else {
    window.wsc = wsc;
    window._status_comm = _status_comm;
  }
})(window);



// WEBPACK FOOTER //
// ./src/libs/communication.js